// extracted by mini-css-extract-plugin
module.exports = {"fallback":"MonarchFallback_fallback__I488x"};